export { default } from './AutocompleteComponent'
